import Events from "./Events"
import EventDispatcher from "./EventDispatcher"

/**
* Ajax Swap - ASwap
**/
class ASwapDispatcher extends EventDispatcher {
  /**
  * ASwap class constructor
  * @param {*} params
  * @constructor
  **/
  constructor( params = {} ) {
    super();
    for ( let param in params ) {
      this[param] = params[param]
    }
    // PRIVATE 
    this.asAnimTimeout1 = null;
    this.asAnimTimeout2 = null;
    this.currentTrigger = null;
    this.currentUrl = null;
    this.prevUrl = null;
    this.ajaxStore = [];
    this.asHistory = [];
    this.freshContent = document.querySelector(this.swapSelector);

  }
  
  /**
  * trace warning (console.warn)
  * @param obj {Mixed}
  **/
  warning(...obj) {
    console.warn(...obj);
  }
  /**
  * store (cache) the result
  * @param {String} url
  * @param {String} result 
  **/
  storeResult(url, result) { 
    if (this.cacheOn) {
      this.ajaxStore.push({url, result});
    }
  }
  /**
  * get the result from cache (if exists)
  * @param {String} url
  * @returns {String|Boolean} stored result / false
  **/
  getStoredResult(url) {
    let result = false;
    this.ajaxStore.forEach( (r, index)=> {      
      if (r.url == url) {        
        result = r.result;
      }
    });
    return result;
  }
  clearCache(url = null) {
    if (url) {
      this.clearCacheByUrl(url);
    } else {
      this.ajaxStore = [];
    }
  }
  clearCacheByUrl(url) {
    let newStore = [];
    this.ajaxStore.forEach( (r, index)=> {      
      if (r.url !== url) {
        newStore.push(r);
      }
    });
    this.ajaxStore = newStore;
  }
  /**
  * parse the result and return content between a tag, eg. <body></body>
  * @param result {String} the ajax request result
  * @param tag {String} the tag name, eg. body
  * @returns {String|Boolean} 
  **/
  getTagFromResult(result, tag, index = 0) {
    let regex = new RegExp('<' + tag + '[^>]*>((.|[\n\r])*)<\/' + tag + '>');
    let body = regex.exec(result);
    if (body && body[index]) {
      return body[index];
    } else {
      this.warning("AS problem - " + tag + " could not be extracted, index:", index);
      return false;
    }
  }
  /**
   * ###
   */
  getElementFromResult(result, tagName) {
    let htmlStr = this.getTagFromResult(result, tagName, 1)
    let el = document.createElement(tagName)
    el.innerHTML = htmlStr.trim()
    return el
  }

  /**
  * swap the meta and title tags in document's <head>
  * @param result {String} the ajax request result
  **/
  swapHeadMeta(result) {
    const freshHead = this.getElementFromResult(result, "head")
    if (!freshHead) {
      this.warning("AS problem - head was not found in result");
      return false;
    }
    const list = [...freshHead.querySelectorAll("*")]
    list.forEach((el, index) => {
      // swap if TITLE or META
      switch (el.nodeName.toLowerCase()) {
        case "title":
          document.title = el.innerText
          break;
        case "meta":
          const name = el.getAttribute("name")
          const property = el.getAttribute("property")
          const itemprop = el.getAttribute("itemprop")
          const content = el.getAttribute("content")
          // get the meta query string
          let query = 'html head meta'
          query += (name ? '[name="' + name + '"' : '')
          query += (property ? '[property="' + property + '"' : '')
          query += (itemprop ? '[itemprop="' + itemprop + '"' : '')
          let metaEl = document.querySelector(query)
          if (metaEl && content) {
            metaEl.setAttribute("content", content)
          }
          break;
      }
    })
    
  }
  /**
  * swap the HTML class names
  * @param result {String} the ajax request result
  **/
  //
   swapBodyToHtmlClasses(result) {    
    let html = document.createElement('html')
    html.innerHTML = this.getTagFromResult(result, "body")
    let body = html.querySelector('body')
    if (body.dataset.htmlClasses) {
      document.documentElement.className = body.dataset.htmlClasses
    }
  }
  /**
  * get the swap content from ajax request result (select by swapSelector)
  * @param result {String} the ajax request result
  * @returns {jQuery}
  **/
  getFreshContentFromResult(result) {    
    let body = this.getTagFromResult(result, "body");
    if (!body) {
      this.warning("AS problem - body was not found in result");
      if (this.refreshOnContentParseError) {
        window.location.reload();
      }
      return false;
    }    
    let html = document.createElement('html');
    html.innerHTML = body;
    return html.querySelector(this.swapSelector)
  }

  /**
  * handle result - animation classes, dispatch events, swap content
  * @param result {String} the ajax request result
  **/
  handleResult(result) {
    // store fresh content in public variable
    this.freshContent = this.getFreshContentFromResult(result);
    const swap = document.querySelector(this.swapSelector)
    // dispatch event
    this.dispatch(Events.NAV_REQUEST_LOADED);
    this.dispatch(Events.NAV_VIEW_HIDE);
    // timeout
    clearTimeout(this.asAnimTimeout1);
    clearTimeout(this.asAnimTimeout2);
    this.asAnimTimeout1 = setTimeout(()=> {
      this.dispatch(Events.NAV_VIEW_HIDDEN);
      this.dispatch(Events.NAV_SWAP_START);
      if (this.freshContent) {
        // swap stage classes
        swap.setAttribute("class", this.freshContent.getAttribute("class"))
        // swap content
        swap.innerHTML = this.freshContent.innerHTML
      }
      // swap head (meta)
      this.swapHeadMeta(result);
      setTimeout(() => {
        this.swapBodyToHtmlClasses(result);
      }, 10)
      // scroll up
      if (this.resetScrollOn && (!this.currentTrigger || !this.currentTrigger.classList.contains(this.noScrollClassName))) {
        this.resetScrollPosition();
      }
      // dispatch swap event
      this.dispatch(Events.NAV_SWAP_COMPLETE);
      // animate in
      this.dispatch(Events.NAV_VIEW_SHOW);
      this.asAnimTimeout2 = setTimeout(()=> { 
        // dispatch event
        this.dispatch(Events.NAV_VIEW_SHOWN);
      }, this.animationTimeShow);        
    }, this.animationTimeHide);
    
  }
  /**
  * get current URL
  * @returns {String}
  **/
  getCurrentUrl() {
    return this.currentUrl;
  }

  /**
  * extract the last name from path and return it
  * @param {Boolean} includeParams - params divided by "," found always at the end of path
  * @returns {String}
  **/
  getParentPathFromUrl(includeParams = true) {
    let current = window.location.pathname;
    let arr = current.split('/');
    let url = "";
    for (var i = 0; i < arr.length - 1; i++) {
      if (arr[i] && arr[i] != "") {
        url+= "/" + arr[i];
      }
    }
    if (includeParams) {
      let params = current.split(',');      
      for (var i = 1; i < params.length; i++) {
        if (params[i] && params[i] != "") {
          url+= "," + params[i];
        }
      }
    }
    return url;
  }

  /**
  * back - history
  * @param noHistory {Boolean} - if the pushState should be skipped (default false)
  **/
  back(noHistory = false) {
    let url = '/';
    if (this.asHistory.length > 1) {
      url = this.asHistory[this.asHistory.length - 2];
    } else {
      url = this.getParentPathFromUrl();
    }
    this.openURL(url);
  }

  /**
  * scroll back up
  **/
  resetScrollPosition() {
    // set scrollBehavior to auto
    document.documentElement.style.scrollBehavior = 'auto';
    // scroll without animation
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 5)
    // set scrollBehavior to it's default value
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = this.defaultDocumentScrollBehavior ? this.defaultDocumentScrollBehavior : 'smooth';
    }, 5)
  }

  /**
   * Preload URL
   * @param url {String}
   */
  preloadURL(url) {
    if (url == this.getCurrentUrl()) {
      return false
    }
    let result = this.getStoredResult(url);
    if (result) {
      return false
    }
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        // this.trace('URL was preloaded', url, xhr.responseText)
        this.storeResult(url, xhr.responseText);
      }
    };
    xhr.open('GET', url);
    xhr.send();
    
  }
  /**
   * Form submit
   */
  formSubmit(form) {
    const useCache = !form.classList.contains(this.noCacheClassName);
    let url = form.getAttribute("action");
    if (url.indexOf('://') < 0) {
      this.currentTrigger = form
      const method = form.getAttribute('method') ? form.getAttribute('method').toLowerCase() : 'get'
      const formData = new FormData(form);
      if (method == 'get') {
        // for GET add data string to URL
        const dataStr = new URLSearchParams(formData).toString();
        const dataSep = url.indexOf('?') > -1 ? '&' : '?';
        url = dataStr && method == 'get' ? (url + dataSep + dataStr) : url;
      }
      this.submit(url, formData, method, false, useCache);
    }
  }
  /**
   * 
   * @param {string} url 
   * @param {*} data 
   * @param {string} method 
   * @param {boolean} noHistory
   * @param {boolean} useCache
   */
  submit(url, formData, method, noHistory = false, useCache = true) {
    // dispatch event
    this.dispatch(Events.NAV_REQUEST_URL);
    this.prevUrl = this.currentUrl;
    this.currentUrl = url;
    if (!noHistory) {
      this.pushState(url);
    }
    switch (method) {
      case 'post':
        // POST
        this.loadURL(url, formData, method, false);
        break;
      default:
        // GET / PUT / PATCH / DELETE
        let result = useCache ? this.getStoredResult(url) : null;
        if (result) {
          this.handleResult(result);
        } else {
          this.loadURL(url, formData, method, useCache);
        }
        break;
    }
  }
  /**
  * go to URL
  * @param url {String}
  * @param noHistory {Boolean} - if the pushState should be skipped (default false)
  **/
  openURL(url, noHistory = false, useCache = true) {
    // check if url changed
    if (url == this.getCurrentUrl()) {
      this.trace("url didn't change", url);
      this.dispatch(Events.NAV_REQUEST_SAME_URL);
      if (this.refreshOnSameUrl) {
        window.location.href = url;
      }
      return false;
    }
    this.submit(url, {}, 'get', noHistory, useCache)
  }
  /**
  * Ajax GET request URL
  * @todo ajax request error handler
  * @param url {String}
  **/
  loadURL(url, data = {}, method = 'get', useCache = true) {
    // dispatch event
    this.dispatch(Events.NAV_REQUEST_LOAD);
    this.trace("ASwap load: ", url); 
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (useCache) {
          this.storeResult(url, xhr.responseText);
        }
        this.handleResult(xhr.responseText);
      }
    };
    xhr.open(method, url);
    xhr.send(data);
  }
  /**
  * history pushState (URL)
  * @param url {String}
  **/
  pushState(url) {
    // store url in local history
    this.asHistory.push(url);
    if (!this.historyEnabled) {
      return false;
    }
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, url);
    }
  }
  /**
  * on history back - open URL (without pushState)
  * @param e {Event}
  **/
  onHistoryBack(e) {
    e.preventDefault();
    let url = window.location.pathname + window.location.search;
    // console.log("HISTORY BACK", url);
    this.openURL(url, true);
  }
  /**
  * store / cache the initial URL
  **/  
  storeInitUrl() {
    let url = window.location.pathname + window.location.search;
    let result = document.documentElement.innerHTML;    
    this.storeResult(url, result);
    this.currentUrl = url;
  }
  isLinkElementValid(a) {
    let result = false
    if (a) {
      if (!a.classList.contains(this.noSwapClassName) && a.getAttribute("target") != "_blank") {
        result = true
      }
    }
    return result
  }
  isFormElementValid(f) {
    let result = false
    if (f) {
      if (f.matches(this.formsSelector) && !f.classList.contains(this.noSwapClassName)) { 
        result = true
      }
    }
    return result
  }
  
  /**
   * ### Event handlers ###
   */
  onDocumentClick(e) {
    const a = e.target.closest('a');
    if (!a) {
      return;
    }
    if (this.isLinkElementValid(a) && !e.metaKey & !e.ctrlKey) {
      const useCache = !a.classList.contains(this.noCacheClassName);
      const url = a.getAttribute("href");
      if (url.indexOf('://') < 0) {
        e.preventDefault()
        this.currentTrigger = a
        this.openURL(url, false, useCache);
      }
    }
  }

  onDocumentMouseover(e) {
    if (e.target.tagName !== 'A') {
      return;
    }
    const a = e.target
    if (this.isLinkElementValid(a)) {
      const useCache = !a.classList.contains(this.noCacheClassName);
      if (useCache) {
        const url = a.getAttribute("href");
        this.preloadURL(url)
      }
    }
  }
  // SUBMIT
  onDocumentSubmit(e) {
    if (e.target.tagName == 'FORM') {
      if (this.isFormElementValid(e.target)) {
        e.preventDefault();
        this.formSubmit(e.target);
      }
    }
  }
  // Swipe touch start event
  handleTouchStart = (e) => {
    const firstTouch = e.touches[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  }
  // Swipe touch move event
  handleTouchMove = (e) => {
    if ( !this.xDown || !this.yDown ) {
      return;
    }
    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;
    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;
    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
      if (Math.abs(xDiff) > this.swipeMinDistance) {
        if ( xDiff > 0 ) {
          this.handleSwipe(e, 'left');
        } else {
          this.handleSwipe(e, 'right');
        }
      }
    } else if (Math.abs(yDiff) > this.swipeMinDistance) {
      if ( yDiff > 0 ) {
        this.handleSwipe(e, 'up');
      } else { 
        this.handleSwipe(e, 'down');
      }
    }
    /* reset values */
    this.xDown = null;
    this.yDown = null;
  }
  // handle SWIPE direction
  handleSwipe = (e, direction) => {
    const d = e.target.closest('[data-as-swipe-' + direction + ']')
    if (d) {
      const path = d.getAttribute('data-as-swipe-' + direction);
      if (path) {
        this.openURL(path);
      }
    }
  }
  /**
  * add event listeners
  **/
  addEventListeners() {    
    // catch all a click events
    document.addEventListener('click', this.onDocumentClick.bind(this), false)
    // preload on hover
    if (this.preloadOnHover) {
      document.addEventListener('mouseover', this.onDocumentMouseover.bind(this), false)
    }
    // forms?
    if (this.formsEnabled) {
      document.addEventListener('submit', this.onDocumentSubmit.bind(this), false)
    }
    // swipe?
    if (this.swipeEnabled) {
      document.addEventListener('touchstart', this.handleTouchStart, false);
      document.addEventListener('touchmove', this.handleTouchMove, false);
    }
    // browser back button
    window.addEventListener('popstate', this.onHistoryBack.bind(this), false)
  }

  initialDispatch() {    
    this.dispatch(Events.NAV_REQUEST_LOADED);        
    // timeout
    clearTimeout(this.asAnimTimeout1);
    clearTimeout(this.asAnimTimeout2);
    this.asAnimTimeout1 = setTimeout(()=> {
      this.dispatch(Events.NAV_SWAP_COMPLETE);      
      this.dispatch(Events.NAV_VIEW_SHOW);
      this.asAnimTimeout2 = setTimeout(()=> {         
        this.dispatch(Events.NAV_VIEW_SHOWN);
      }, this.asAnimationTime);
    }, this.asAnimationTime);  
  }

  detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
       // Edge (IE 12+) => return version number
       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
  }

  isBrowserSupported() {
    let result = true
    if (this.historyFallback && (!window.history || !window.history.pushState)) {
      this.warning("AS problem - the browser dosn't support history pushState");
      result = false;
    }
    if (this.oldschoolBrowserFallback) {
      // check Internet Explorer (IE)
      let ie = this.detectIE()
      if (ie && ie < 12) {
        this.warning("AS problem - Internet Exlorer browser is not supported");
        result = false;
      }
    }
    return result
  }
  /**
  * init
  **/
  init() {    
    const swap = document.querySelector(this.swapSelector)
    if (!swap) {
      this.warning("AS problem - swap container not found!", this.swapSelector);
      return false;
    }
    // check if browser is supported
    if (!this.isBrowserSupported()) {
      this.initialDispatch();
      return false
    }
    // store init URL
    this.storeInitUrl();
    // initial dispatch (for controllers to do prepare / view)
    this.initialDispatch();
    this.addEventListeners();
  }


}

export default ASwapDispatcher;